import { inject } from "@angular/core";
import { ROUTES } from "@app/shared/constants/routes.constants";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { of, catchError } from "rxjs";
import { RouteService } from "@app/core/services/route.service";

export const TokenGuard = () => {
  const authService = inject(AuthenticationService);
  const router = inject(RouteService);

  // No token, just pass through
  if (!authService.credentials.nodeJsAuthentication.accessToken) {
    return of(true);
  }

  // Get app settings and determine if portal still enabled
  return authService.nodeJsValidateToken().pipe(
    catchError(() => {
      router.navigate([ROUTES.LOGIN]);
      return of(false);
    })
  );
};
